<template>
	<div>
		<!-- 头部 PC -->
		<div class="headbox fcss" v-if="$route.path!='/login'">
			<Headbox/>
		</div>
		
		<!-- <div class="headbox" style="opacity: 0;" v-if="$route.path!='/home'">
			<Headbox/>
		</div> -->
		
		<!-- 内容 -->
		<div class="home_msg">
			<router-view />
		</div>
		
		<!-- 底部 -->
		<div class="Footbox" v-if="$route.path!='/login'">
			<Footbox/>
		</div>
		
	</div>
</template>
<script>
import { login } from "/src/api/api.js"
import Headbox from '@/components/head.vue';
import Footbox from '@/components/foot.vue';
export default {
	components:{Headbox,Footbox},
	data(){
		return {
			
		}
	},
	mounted() {
		
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #F7F2EC;
}
</style>
<style lang="scss" scoped>


</style>